export enum unit {
    SI = 'Metric',
    Imperial = 'Imperial',
}

export enum EProjectType {
    Macro1 = 'Macro1',
    Macro2 = 'Macro2',
}
